/* eslint-disable */
import '@/js/desktop/globalIncludes';
import '@/js/desktop/globalComponents';

import '@/css/desktop/search';
import '@/css/desktop/atlas/landing-destinations-header.scss';
import '@/css/desktop/atlas/landing-content.css';
import '@/css/desktop/atlas/landing-destinations-list.css';

import SubscribeForm from "@fr/pages/desktop/travelata/travelata/atlas/View/SubscribeForm";
import SearchFromAutocomplete from "@/js/desktop/components/searchFormAutocomplete/searchFormAutocomplete-controller";
import DirectionsRepository from "@/js/common/Domain/Repository/Directions";
import RestTypesRepository from "@/js/common/Domain/Repository/RestTypes";
import NewYearIndexView from './View/NewYearIndex'

import './landing-new-year.scss';

var Controller = Backbone.View.extend({
	view: null,
	initSubscribeForm() {
		new SubscribeForm();
	},
	initialize: function() {
		var self = this;
		_.each(window.defaultDirections, function(direction) {
			direction.link = direction.link.split('#')[0];
		});

		RestTypesRepository.repository.init(window.defaultRestTypes);
		DirectionsRepository.repository.init({
			directions:window.defaultDirections,
			prices:window.defaultPrices
		});
		this.view = new NewYearIndexView();

		this.initSubscribeForm();
	}
});

$(() => {
	new Controller({
		el: 'body'
	});

	new SearchFromAutocomplete({
		el: "body"
	});
});